import React, { Fragment, PureComponent } from 'react';
import Breadcrumbs from '~/UI/Breadcrumbs/Breadcrumbs';
import BreadcrumbsItem from '~/UI/Breadcrumbs/BreadcrumbsItem';

import styles from './styles.less';

interface Props {
	children: React.ReactNode;
	styles?: { header: string; in: string };
}

export default class Header extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { children, styles } = this.props;

		return (
			<Fragment>
				<Breadcrumbs>
					<BreadcrumbsItem to='/'>Search</BreadcrumbsItem>
					<BreadcrumbsItem>Search Results</BreadcrumbsItem>
				</Breadcrumbs>
				<div className={styles?.header || ''}>{children}</div>
			</Fragment>
		);
	}
}
